export default __webpack_public_path__ + "static/10-2--19dd398121819ee1df927f9841d0d028.png";